export default "__VITE_ASSET__CFB3PAK2__"